<app-dropdown #languageSelector class="w-full block"
              [dropdownWidthClass]="'w-full block text-normal font-medium p-2 text-16 rounded-md border-none ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-transparent leading-6 bg-transparent'">
    <div class="dropdown-button">
        <div type="button" class="flex cursor-pointer items-center w-full text-center p-1 gap-x-1 text-md font-semibold leading-6">
            <div class="w-full text-gray-400 text-xl leading-6" [ngStyle]="{'font-family': seatedItem}">

                @if(languageSelector.isOpen){
                    <input type="text"
                           autofocus="autofocus"
                           (click)="stopPropogation($event)"
                           [(ngModel)]="searchText"

                           class="block text-normal h-full font-medium w-full text-16 rounded-md border-none
                                     ring-inset ring-0
                                     border-0 focus:outline-none focus:ring-0
                                     focus:ring-inset focus:ring-transparent leading-6 bg-transparent" />
                } @else {
                    @if(seatedItem){
                        {{seatedItem}}
                    } @else {
                        {{'select_font' | translate}}
                    }
                }
            </div>
        </div>
    </div>

    <div class="dropdown-options">
        <div class="absolute top-full max-h-[300px] z-10 mt-3 w-screen max-w-md overflow-y-auto rounded-3xl bg-input shadow-lg ring-1 ring-gray-900/5">
            @for(font of filteredFonts; track $index){
                <div class="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm leading-6 hover:bg-card-hover">
                    <button (click)="onFontChange(font)" [ngStyle]="{'font-family': font}" type="button" class="inline-flex w-full px-4 py-2 text-xl leading-6 hover:bg-card text-normal">
                        {{font}}
                    </button>
                </div>
            }
        </div>
    </div>
</app-dropdown>